// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"971fc592","233":"33bec492","355":"5e2c24b1","606":"bcdff168","819":"b29459c7"}[chunkId] + ".chunk.js";
};